import { useState, useEffect, useRef } from 'react';

export default function useComponentVisible( initValue, callback) {
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (initValue && ref.current && !ref.current.contains(event.target)) {
            callback();
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    });

    return { ref };
}